import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press6',
  templateUrl: './notice-press6.component.html',
  styleUrls: ['./notice-press6.component.scss']
})
export class NoticePress6Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
